export default class Contact {
    constructor (
      _id    = 1,
      _name  = "", 
      _email = "", 
    ){
      this.id    = _id
      this.name  = _name;
      this.email = _email;
    }
}
  